import React, { Component } from 'react';
import { connect } from 'react-redux';
import { closeModal } from '../../actions/modals';
import Modal from 'react-modal';
import ModalTelegramSubscribe from './ModalTelegramSubscribe';
import AffiliateSignUpModal from './AffiliateSignUpModal';
import AffiliateSignInModal from './AffiliateSignInModal';
import AffiliatePasswordRecoveryModal from './AffiliatePasswordRecoveryModal';
import AdvertiserRegistrationSuccessModal from './AdvertiserRegistrationSuccessModal';
import AdvertiserRegistrationErrorModal from './AdvertiserRegistrationErrorModal';
import ConvertPartyTicketModal from './ConvertPartyTicketModal';

const modalStyles = {
  overlay: {
    background: 'rgba(34, 34, 34, .8)',
    zIndex: '10',
    overflowY: 'auto',
  },
  content: {
    background: 'none',
    border: 'none',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    left: '0',
    right: '0',
    top: '0',
    bottom: '0',
  },
};

class ModalRoot extends Component {
  state = {
    isOpen: false,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.isOpen !== this.props.isOpen) {
      this.setState(() => ({
        isOpen: this.props.isOpen,
      }));
    }
  }

  closeModal = (e, callback = function () {}) => {
    this.props.closeModal();
    callback();
  };

  getModalByType = (type) => {
    const { modalProps } = this.props;
    switch (type) {
      // case 'telegramSubscribe':
      //   return (
      //     <ModalTelegramSubscribe
      //       closeModal={this.closeModal}
      //       {...modalProps}
      //     />
      //   );

      // case 'affiliateSignUp':
      //   return (
      //     <AffiliateSignUpModal closeModal={this.closeModal} {...modalProps} />
      //   );

      case 'affiliateSignIn':
        return <AffiliateSignInModal closeModal={this.closeModal} {...modalProps} />;

      // case 'affiliatePasswordRecovery':
      //   return (
      //     <AffiliatePasswordRecoveryModal
      //       closeModal={this.closeModal}
      //       {...modalProps}
      //     />
      //   );

      case 'advertiserRegistrationSuccess':
        return <AdvertiserRegistrationSuccessModal closeModal={this.closeModal} {...modalProps} />;

      case 'advertiserRegistrationError':
        return <AdvertiserRegistrationErrorModal closeModal={this.closeModal} {...modalProps} />;

      case 'convertPartyTicket':
        return <ConvertPartyTicketModal closeModal={this.closeModal} {...modalProps} />;

      default:
        return null;
    }
  };

  render() {
    const { isOpen } = this.state;
    const { modalType, modalProps, children } = this.props;
    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={this.closeModal}
        ariaHideApp={false}
        style={modalStyles}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        className={'modal-slide-in'}
        closeTimeoutMS={300}
        {...modalProps}
      >
        {this.getModalByType(modalType) || children}
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state.modals,
});

const mapDispatchToProps = (dispatch) => ({
  closeModal: () => dispatch(closeModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalRoot);
